import React from "react"
import { Card } from "react-bootstrap"
import { colors } from "@src/constants"

interface RoleCardProps {
  text: string
  isPending?: boolean
  brandColor?: string
}

export const RoleCard: React.FC<RoleCardProps> = ({ text, isPending = false, brandColor }) => {
  return (
    <Card
      className="d-flex align-items-center justify-content-center"
      style={{
        height: 25,
        backgroundColor: colors.middleGray,
        borderWidth: 1,
        borderColor: isPending ? brandColor : colors.gentleGray,
      }}
    >
      <b
        className="small ms-1 me-1"
        style={{
          textAlign: "center",
        }}
      >
        {text}
      </b>
    </Card>
  )
}
